<template>
  <section></section>
</template>

<script>
export default {
  props: {
    data: Array,
  },
};
</script>